module.exports = __webpack_public_path__ + "img/icon3.abba3c49.svg";